import { useSelector } from "react-redux";
import { FEATURES } from "../../../app/appConstants";
import { getAppFeatures } from "../../../app/appSelectors";
import MobileAppOnboarding from "../MobileAppOnboarding/MobileAppOnboarding";
import { Redirect, useLocation } from 'react-router-dom';
import { MobileRouterPaths } from '../../mobileAppConstants';

function MobileAppFirstStartWrapper() {
    const features = useSelector(getAppFeatures);
    const location = useLocation();

    if (features[FEATURES.MOBILE_ONBOARDING] && !features[FEATURES.DEMO_MODE]) {
        return <MobileAppOnboarding/>;
    }

    return <Redirect to={{
        pathname: MobileRouterPaths.default,
        search: location.search,
    }}/>
}

export default MobileAppFirstStartWrapper;
